exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/admin-page/admin-page.component.css
// module id = ../../../../../src/app/admin-page/admin-page.component.css
// module chunks = main